import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  EditCustomer,
  ViewCustomer,
  ViewCustomerSearchPage,
} from '../actions/all-customers-summary.actions';
import { ViewMember, ViewMemberSearchPage } from '../actions/lmembers-summary.actions';
import { SharedState } from '../models/shared.models';

const initialState: SharedState = {
  viewMemberSearch: true,
  viewMemberSummary: false,
  viewCustomerSummary: false,
  customerActiveTab: 'summary' as const,
  selectedSearchTabIndex: 0,
};

export const SharedReducer = createReducer(
  initialState,
  on(ViewMember, (state) => ({
    ...state,
    viewMemberSearch: false,
    viewMemberSummary: true,
    viewCustomerSummary: false,
    selectedSearchTabIndex: 0,
  })),
  on(ViewMemberSearchPage, (state) => ({
    ...state,
    viewMemberSearch: true,
    viewMemberSummary: false,
    viewCustomerSummary: false,
    customerActiveTab: 'summary' as const,
    selectedSearchTabIndex: 0,
  })),
  on(ViewCustomer, (state) => ({
    ...state,
    viewMemberSearch: false,
    viewMemberSummary: false,
    viewCustomerSummary: true,
    customerActiveTab: 'summary' as const,
    selectedSearchTabIndex: 1,
  })),
  on(EditCustomer, (state) => ({
    ...state,
    viewMemberSearch: false,
    viewMemberSummary: false,
    viewCustomerSummary: true,
    customerActiveTab: 'details' as const,
    selectedSearchTabIndex: 1,
  })),
  on(ViewCustomerSearchPage, (state) => ({
    ...state,
    viewMemberSearch: true,
    viewMemberSummary: false,
    viewCustomerSummary: false,
    customerActiveTab: 'summary' as const,
    selectedSearchTabIndex: 1,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) =>
    activeComponent === 'AllCustomersComponent' || activeComponent === 'MemberSearchComponent'
      ? { ...state }
      : { ...initialState },
  ),
);
